import { CheckboxSize } from './checkbox.types'

// Note: the box's outer size, border included (the box is border-box).
export const CHECKBOX_BOX_SIZE_MAP: Record<CheckboxSize, string> = {
  medium: '2rem',
  small: '1.6rem',
}

export const CHECKBOX_ICON_SIZE_MAP: Record<CheckboxSize, string> = {
  medium: '1.6rem',
  small: '1.2rem',
}
